export default __webpack_public_path__ + "static/media/1-2-3.21d765f1.webp";